/**
 * Deutsche Resource — Default-Sprache.
 * Top-Level Keys = Pages/Sections, Nested = Strings darin.
 */

export const de = {
  common: {
    siteName: 'Die Sizilianer',
    siteTagline: 'Sizilianische Spezialitäten in Dorsten',
    loading: 'Laden…',
    error: 'Fehler',
    save: 'Speichern',
    cancel: 'Abbrechen',
    submit: 'Senden',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    open: 'Öffnen',
    back: 'Zurück',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
  },

  nav: {
    home: 'Home',
    menu: 'Speisekarte',
    reservation: 'Reservierung',
    events: 'Events',
    gallery: 'Galerie',
    about: 'Über uns',
    contact: 'Kontakt',
    impressum: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'AGB',
    newsletter: 'Newsletter',
    laputia: 'La Putia',
  },

  language: {
    label: 'Sprache',
    de: 'Deutsch',
    it: 'Italiano',
    en: 'English',
  },

  menu: {
    eyebrow: 'Buon appetito',
    title: 'Speisekarte',
    lede: 'Authentische sizilianische Küche — frisch zubereitet, mit Liebe serviert. Alle Preise in Euro inkl. MwSt.',
    searchPlaceholder: 'Speise suchen…',
    diet: {
      vegetarian: 'Vegetarisch',
      vegan: 'Vegan',
      glutenFree: 'Glutenfrei',
      lactoseFree: 'Laktosefrei',
      special: 'Heute',
      seasonal: 'Saisonal',
      seasonalUntil: 'Saisonal bis {{date}}',
    },
    filterMatches: '{{count}} Treffer',
    filterReset: 'Filter zurücksetzen',
    empty: {
      title: 'Keine Speisen verfügbar',
      description: 'Aktuell sind keine Speisen verfügbar. Bitte später noch einmal vorbeischauen.',
      filteredTitle: 'Keine passenden Gerichte',
      filteredDescription: 'Keine Gerichte entsprechen den gewählten Filtern. Setze die Filter zurück, um die ganze Karte zu sehen.',
    },
    allergens: 'Allergene',
    price: 'Preis',
    tableContext: {
      tavolo: 'Tavolo',
      table: 'Tisch',
      callService: 'Service rufen',
      hint: 'Stöbern Sie in unserer Speisekarte. Bestellung erfolgt direkt beim Personal.',
    },
  },

  home: {
    pageTitle: 'Sizilianisches Restaurant',
    pageDescription: 'Authentische sizilianische Küche im Herzen von Dorsten.',
    hero: {
      imageAlt: 'Sizilianische Szene mit Trinacria-Figur, Ätna, antikem Tempel und Feigenkaktus',
      kicker: 'Cucina siciliana autentica',
      title: 'DIE SIZILIANER',
      ledeLine1: 'Authentische Rezepte. Beste Zutaten.',
      ledeLine2: 'Ein Stück Sizilien. Mitten in Dorsten.',
      reserveCta: 'Tisch reservieren',
    },
    trustLine: '4,6 von 5 bei Google · über 1.700 Bewertungen →',
    kueche: {
      eyebrow: 'Unsere Küche',
      title: 'Ein Fest für die Sinne',
      sub: 'Sizilianische Aromen, traditionell zubereitet. Mit Liebe serviert.',
      cards: {
        antipasti: 'Antipasti',
        antipastiSub: 'Der perfekte Beginn',
        pasta: 'Pasta',
        pastaSub: 'Tradition & Leidenschaft',
        pesce: 'Pesce',
        pesceSub: 'Frisch aus dem Meer',
        dolci: 'Dolci',
        dolciSub: 'Süße Verführung',
      },
    },
    events: {
      eyebrow: 'Events',
      title: 'Genuss. Musik. Momente.',
      text: 'Erleben Sie besondere Abende mit sizilianischer Küche, Live-Musik und echter Gastfreundschaft.',
      cta: 'Alle Events ansehen',
      loading: 'Lade…',
      emptyTitle: 'Aktuell keine Termine',
      emptyText: 'Wir planen unsere nächsten Events. Schauen Sie bald wieder vorbei oder buchen Sie uns für Ihr Event.',
      emptyCta: 'Ape buchen',
      fallbackTitle: 'Ape-Event',
      more: 'Mehr erfahren',
    },
    laPutiaTeaser: {
      badge: 'Neu: Unser Laden',
      title: 'La Putia',
      imageAlt: 'La Putia',
      taglineFallback: 'Sizilianische Bottega in Dorsten',
      text: 'Sizilianische Spezialitäten zum Mitnehmen — Käse, Wurst, Olivenöl aus Agrigento, Arancini und sizilianische Brötchen. Direkt in der Dorstener Innenstadt.',
      ctaOpen: 'La Putia entdecken',
      ctaClosed: 'Bald hier — mehr erfahren',
    },
  },

  galerie: {
    title: 'Galerie',
    scriptLine: 'Impressioni',
    lede: 'Sizilien in Bildern — Illustrationen der Insel, ihrer Farben und ihrer Küche, die uns inspirieren.',
    instagram: 'Mehr Eindrücke folgen uns auf Instagram',
    captions: {
      sizilien: 'Sizilien',
      antipasti: 'Antipasti',
      pasta: 'Pasta',
      trinacria: 'Trinacria',
      pesce: 'Pesce',
      cannoli: 'Cannoli',
      ficoDIndia: "Fico d'India",
      olivo: 'Olivo',
      piazza: 'Piazza',
      limoni: 'Limoni',
      pomodoro: 'Pomodoro',
      cucina: 'Cucina',
    },
  },

  laPutia: {
    pageTitle: 'La Putia',
    pageDescription: 'La Putia — Sizilianische Bottega in der Dorstener Innenstadt. Feinkost, Streetfood und Spezialitäten zum Mitnehmen. Von den Sizilianern.',
    storeDescriptionFallback: 'Sizilianische Bottega in der Dorstener Innenstadt',
  },

  ape: {
    shared: {
      toHome: 'Zur Startseite',
      toApeBookings: 'Zu den Ape-Buchungen',
      loadingBooking: 'Lade Buchung…',
      bookingNotFound: 'Buchung nicht gefunden',
      bookingLoadError: 'Die Buchung konnte nicht geladen werden.',
      noTokenTitle: 'Kein Token',
      unknownError: 'Unbekannter Fehler',
      errorPrefix: 'Fehler: {{message}}',
      flatPrice: 'Pauschalpreis',
      statusConfirmed: 'Bestätigt',
      statusCancelled: 'Storniert',
      timeAt: '{{time}} Uhr',
    },
    requestReceived: {
      pageTitle: 'Anfrage erhalten',
      scriptLine: 'Grazie mille',
      title: 'Anfrage erhalten',
      body: 'Wir haben Ihre Anfrage erhalten und melden uns innerhalb von 48 Stunden telefonisch bei dir, um die Details zu besprechen und ein verbindliches Angebot zu erstellen.',
      whatNow: 'Was passiert jetzt?',
      step1: '<strong>1.</strong> Wir prüfen die Verfügbarkeit und rufen dich an',
      step2: '<strong>2.</strong> Wir besprechen Menü, Personenzahl und Ablauf',
      step3: '<strong>3.</strong> Du erhältst ein schriftliches Angebot per Mail',
      step4: '<strong>4.</strong> Du nimmst per Klick verbindlich an — fertig',
      callNow: 'Jetzt anrufen',
    },
    bookingConfirmed: {
      pageTitle: 'Buchung bestätigt',
      noTokenText: 'Diese Seite wird nur über den Link in der Bestätigungs-Mail aufgerufen.',
      scriptCancelled: 'Schade',
      scriptConfirmed: 'Wir freuen uns',
      titleCancelled: 'Buchung storniert',
      titleConfirmed: 'Buchung bestätigt',
      introCancelled: 'Diese Buchung wurde storniert. Wir hoffen auf eine andere Gelegenheit.',
      introConfirmed: 'Ihre Ape-Buchung ist verbindlich. Wir freuen uns auf das Event!',
      eventFallback: 'Event',
      statusBinding: 'Verbindlich',
      cancelCta: 'Stornieren',
      mailNote: 'Du erhältst zusätzlich eine Bestätigungs-Mail mit allen Details.',
    },
    cancel: {
      pageTitle: 'Buchung stornieren',
      noTokenText: 'Diese Seite wird nur über den Storno-Link in der Bestätigungs-Mail aufgerufen.',
      toastAlready: 'Buchung war bereits storniert.',
      toastCancelled: 'Buchung wurde storniert.',
      scriptLine: 'Bis zum nächsten Mal',
      cancelledTitle: 'Buchung storniert',
      cancelledBody: 'Ihre Buchung am {{date}} wurde storniert. Wir hoffen, dich bald wieder bei einer anderen Gelegenheit zu sehen.',
      newRequest: 'Neue Anfrage',
      confirmTitle: 'Buchung stornieren?',
      confirmText: 'Diese Buchung wird storniert und das Datum wieder freigegeben. Diese Aktion kann nicht rückgängig gemacht werden.',
      bookingFallback: 'Buchung',
      name: 'Name',
      date: 'Datum',
      time: 'Uhrzeit',
      location: 'Ort',
      reasonLabel: 'Grund (optional)',
      reasonHint: 'Hilft uns, unseren Service zu verbessern',
      reasonPlaceholder: 'z. B. Datum hat sich geändert',
      keepButton: 'Doch behalten',
      cancelButton: 'Buchung stornieren',
    },
    quote: {
      pageTitle: 'Ihr Angebot',
      noTokenTitle: 'Kein Token vorhanden',
      noTokenText: 'Diese Seite wird nur über den Link in der Angebots-Mail aufgerufen.',
      toastAlready: 'Buchung war bereits bestätigt.',
      toastAccepted: 'Buchung verbindlich bestätigt!',
      loading: 'Lade Angebot…',
      notFound: 'Angebot nicht gefunden',
      loadError: 'Das Angebot konnte nicht geladen werden.',
      scriptLine: 'Ihr Angebot',
      cancelledTitle: 'Buchung wurde bereits storniert',
      cancelledText: 'Wenn du das Event doch wieder aktivieren möchtest, ruf uns an.',
      confirmedTitle: 'Buchung bereits bestätigt',
      confirmedText: 'Wir freuen uns auf dich!',
      keyFacts: 'Eckdaten',
      statusPleaseConfirm: 'Bitte bestätigen',
      guestsApprox: 'ca. {{guests}} Personen',
      notes: 'Hinweise',
      acceptHint: 'Wenn das Angebot so passt, einfach hier verbindlich annehmen. Wir senden dir direkt eine Bestätigungs-Mail.',
      acceptCta: 'Angebot verbindlich annehmen',
      phoneHint: 'Lieber telefonisch Rücksprache halten?',
    },
  },

  reservation: {
    title: 'Tisch reservieren',
    eyebrow: 'Reservierung',
    scriptLine: 'Riserva il tuo tavolo',
    intro: 'Wählen Sie Datum, Uhrzeit und Personenzahl — wir bestätigen Reservierungen bis 6 Personen sofort.',
    // Reservierungsstopp (0089): Standardtext, wenn kein individueller
    // Gast-Hinweis (reservations_stop_message) hinterlegt ist.
    stop: {
      title: 'Zurzeit keine Online-Reservierungen',
      body: 'Aufgrund sehr hoher Nachfrage können wir im Moment leider keine neuen Reservierungen annehmen. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
      // 0090: Standardtext für TAGES-Stopps — „später versuchen" wäre hier
      // die falsche Handlungsanweisung, andere Tage sind ja buchbar.
      dayBody: 'Für diesen Tag nehmen wir leider keine Online-Reservierungen an. Bitte wählen Sie einen anderen Tag — oder rufen Sie uns an.',
    },
    step1: {
      guestsLabel: 'Wie viele Personen?',
      guestsHint: 'Bis 6 Personen bestätigen wir sofort, für 7–12 Personen auf Anfrage. Ab 13 Personen rufen Sie uns bitte direkt an:',
      dateLabel: 'An welchem Tag?',
      timeLabel: 'Um wie viel Uhr?',
      continue: 'Weiter',
    },
    step2: {
      title: 'Kontaktdaten',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      notes: 'Anmerkungen (optional)',
      notesHint: 'Allergien, Tischvorliebe, Anlass',
      birthday: 'Wir feiern einen Geburtstag',
      birthdayDate: 'Geburtstagsdatum',
      birthdayHint: 'Damit wir das Geburtstagskind kennen',
      areaPreference: 'Bereich-Wunsch (optional)',
      areaInside: 'Innen',
      areaTerrace: 'Terrasse',
      areaNoPreference: 'Egal',
      back: 'Zurück',
      continue: 'Weiter zur Übersicht',
    },
    step3: {
      title: 'Übersicht',
      lede: 'Bitte prüfen Sie Ihre Angaben.',
      submit: 'Verbindlich reservieren',
      submitting: 'Sende…',
    },
    slotPicker: {
      loading: 'Verfügbarkeit wird geladen…',
      emptyTitle: 'Keine freien Zeiten',
      emptyDefault: 'Für diesen Tag sind keine Slots verfügbar.',
      groupLabel: 'Uhrzeit auswählen',
      seatsFree: '{{count}} frei',
    },
    guestsPicker: {
      groupLabel: 'Anzahl Gäste',
      decrease: 'Eine Person weniger',
      increase: 'Eine Person mehr',
      person: 'Person',
      persons: 'Personen',
    },
    datePicker: {
      groupLabel: 'Datum auswählen',
      today: 'Heute',
    },
    availability: {
      title: 'Live-Auslastung',
      today: 'Heute',
      full: 'Voll',
      free: 'frei',
    },
    waitlistForm: {
      errorName: 'Bitte vollständigen Namen eingeben',
      errorEmail: 'Gültige E-Mail erforderlich',
      errorPhone: 'Telefon erforderlich',
      joinFailed: 'Eintrag fehlgeschlagen',
      successTitle: 'Auf der Warteliste!',
      successPosition: 'Du stehst auf <strong>Position {{position}}</strong> für {{date}} um {{time}} Uhr.',
      successNote: 'Wir benachrichtigen dich per Mail sobald ein Platz frei wird.',
      title: 'Auf die Warteliste setzen',
      summaryOne: '{{date}} · {{time}} Uhr · {{guests}} Person',
      summaryMany: '{{date}} · {{time}} Uhr · {{guests}} Personen',
      note: 'Wir schreiben dir sofort, sobald ein Tisch frei wird (Link 24 h gültig).',
      namePlaceholder: 'Vor- und Nachname',
      emailPlaceholder: 'E-Mail',
      phonePlaceholder: 'Telefon',
      notesPlaceholder: 'Anmerkungen (optional)',
      submit: 'Auf Warteliste',
      cancel: 'Abbrechen',
    },
    calendar: {
      addToCalendar: 'Zum Kalender hinzufügen',
      google: 'Google Kalender',
      googleHint: 'Öffnet im Browser',
      apple: 'Apple / Outlook (.ics)',
      appleHint: 'Download und Doppelklick',
      outlook: 'Outlook.com',
      outlookHint: 'Microsoft Web',
      eventTitle: 'Reservierung — Die Sizilianer',
      manageHint: 'Reservierung ansehen, ändern oder stornieren (Link bis zum Reservierungstag gültig):',
      eventDescriptionOne: '{{guests}} Person · Reservierung auf den Namen {{name}}.',
      eventDescriptionMany: '{{guests}} Personen · Reservierung auf den Namen {{name}}.',
      addressLine: 'Die Sizilianer · Im Werth 25 · 46282 Dorsten · Tel. 02362 23279',
    },
    shared: {
      loading: 'Reservierung wird geladen…',
      notFound: 'Reservierung nicht gefunden',
      cardTitle: 'Reservierung',
      name: 'Name',
      date: 'Datum',
      time: 'Uhrzeit',
      guests: 'Personen',
      area: 'Bereich',
      notes: 'Notizen',
      email: 'E-Mail',
      timeAt: '{{time}} Uhr',
      areaInside: 'Drinnen',
      areaTerrace: 'Terrasse',
      addressLine: 'Im Werth 25, 46282 Dorsten',
      route: 'Route →',
      questionsPhone: 'Fragen? Tel.',
      newReservation: 'Neu reservieren',
      toHome: 'Zur Startseite',
      contactUs: 'Kontakt aufnehmen',
      noTokenTitle: 'Kein Reservierungs-Token',
      unknownError: 'Unbekannter Fehler',
      networkError: 'Netzwerkfehler',
      status: {
        cancelled: 'Storniert',
        pending: 'In Prüfung',
        confirmed: 'Bestätigt',
        completed: 'Abgeschlossen',
        noShow: 'Nicht erschienen',
      },
    },
    manage: {
      pageTitle: 'Reservierung verwalten',
      pageDescription: 'Reservierung bei Die Sizilianer in Dorsten ansehen, ändern oder stornieren',
      scriptLine: 'Benvenuti',
      title: 'Ihre Reservierung',
      introOpen: 'Hier können Sie Ihre Reservierung bis zu Ihrem Reservierungstag einsehen, ändern oder stornieren.',
      introInactive: 'Diese Reservierung ist nicht mehr aktiv.',
      editButton: 'Reservierung ändern',
      cancelButton: 'Reservierung stornieren',
      modifyLockedCancel: 'Änderungen sind bis 2 Stunden vor Ihrer Reservierung möglich. Für kurzfristige Änderungen rufen Sie uns bitte an.',
      modifyLockedNoCancel: 'Änderungen sind bis 2 Stunden vor Ihrer Reservierung möglich. Bitte rufen Sie uns für alles Weitere an.',
      edit: {
        scriptLine: 'Andiamo',
        title: 'Reservierung ändern',
        previouslyOne: 'Bisher: {{date}}, {{time}} Uhr, {{guests}} Person',
        previouslyMany: 'Bisher: {{date}}, {{time}} Uhr, {{guests}} Personen',
        guestsLabel: 'Personenzahl',
        dateLabel: 'Datum',
        timeLabel: 'Uhrzeit',
        notesLabel: 'Notizen (optional)',
        areaLabel: 'Sitzbereich',
        hintLargeGroup: 'Bei mehr als 6 Personen prüfen wir die Änderung erneut manuell.',
        hintCallUs: 'Ab 13 Personen rufen Sie uns bitte an:',
        notesPlaceholder: 'z. B. Allergien, Kinderstuhl, Anlass …',
        areaNoPreference: 'Keine Präferenz',
        back: 'Zurück',
        save: 'Änderung speichern',
        saving: 'Wird gespeichert…',
        closedDay: '{{weekday}} ist Ruhetag.',
        pastDate: 'Bitte wählen Sie ein zukünftiges Datum.',
        closedSpecialDay: 'An diesem Tag haben wir geschlossen.',
        noSlots: 'Für diesen Tag sind keine freien Slots verfügbar.',
        toastNoChange: 'Keine Änderungen — alles bleibt wie gehabt.',
        toastPending: 'Änderung gespeichert! Da Ihre Gruppe nun mehr als 6 Personen umfasst, prüfen wir die Reservierung erneut und melden uns.',
        toastSaved: 'Änderung gespeichert! Sie erhalten eine Bestätigung per E-Mail.',
      },
      noTokenText: 'Diese Seite wird nur über den Verwaltungslink in Ihrer Reservierungs-Mail aufgerufen.',
      expiredTitle: 'Dieser Link ist abgelaufen',
      expiredText: 'Der Verwaltungslink ist bis zum Ende Ihres Reservierungstags gültig. Wir freuen uns, Sie bald wieder bei uns begrüßen zu dürfen!',
    },
    confirmed: {
      pageTitle: 'Reservierung',
      pageDescription: 'Ihre Reservierung bei Die Sizilianer in Dorsten',
      scriptLine: 'Vielen Dank',
      titleCancelled: 'Reservierung storniert',
      titlePending: 'Anfrage erhalten',
      titleConfirmed: 'Reservierung bestätigt',
      introCancelled: 'Diese Reservierung wurde storniert.',
      introPending: 'Wir prüfen Ihre Anfrage und bestätigen sie innerhalb von 24 Stunden.',
      introConfirmed: 'Wir freuen uns auf Ihren Besuch!',
      manageHint: 'Über den Verwaltungslink in Ihrer Bestätigungs-Mail können Sie Ihre Reservierung <strong>bis zu Ihrem Reservierungstag</strong> jederzeit ändern oder stornieren.',
      manageButton: 'Reservierung verwalten',
      cancelButton: 'Reservierung stornieren',
      noTokenText: 'Diese Seite wird nur über den Link in der Bestätigungs-Mail aufgerufen.',
    },
    cancelPage: {
      pageTitle: 'Reservierung stornieren',
      pageDescription: 'Stornierung Ihrer Reservierung bei Die Sizilianer in Dorsten',
      toastAlreadyCancelled: 'Reservierung war bereits storniert.',
      toastCancelled: 'Reservierung wurde storniert.',
      errorPrefix: 'Fehler: {{message}}',
      noLinkTitle: 'Kein Storno-Link',
      noLinkText: 'Diese Seite wird nur über den Storno-Link in der Bestätigungs-Mail aufgerufen.',
      loadError: 'Diese Reservierung konnte nicht geladen werden.',
      scriptLine: 'Bis zum nächsten Mal',
      cancelledTitle: 'Reservierung storniert',
      cancelledBody: 'Ihre Reservierung am <strong>{{date}}</strong> um <strong>{{time}} Uhr</strong> wurde storniert. Wir hoffen, Sie bald wieder bei uns begrüßen zu dürfen.',
      confirmTitle: 'Reservierung stornieren?',
      confirmText: 'Diese Reservierung wird storniert und der Tisch wieder freigegeben. Diese Aktion kann nicht rückgängig gemacht werden.',
      reasonLabel: 'Grund (optional)',
      reasonHint: 'Hilft uns, unseren Service zu verbessern',
      reasonPlaceholder: 'z.B. Plan hat sich geändert',
      keepButton: 'Doch behalten',
      cancelButton: 'Reservierung stornieren',
    },
    waitlistClaim: {
      pageTitle: 'Warteliste · Platz sichern',
      pageDescription: 'Sichern Sie Ihren Platz von der Warteliste.',
      noToken: 'Kein Token vorhanden.',
      genericError: 'Fehler',
      loading: 'Lade Daten…',
      expiredTitle: 'Link abgelaufen',
      expiredText: 'Der Reservierungs-Link war nur 24 Stunden gültig. Der Platz wurde inzwischen an die nächste Person auf der Warteliste vergeben.',
      expiredCta: 'Neuen Tisch reservieren',
      claimedTitle: 'Bereits gebucht',
      claimedText: 'Du hast diesen Platz bereits zu einer festen Reservierung gemacht. Eine Bestätigungs-Mail liegt in Ihrem Postfach.',
      successScript: 'Perfetto!',
      successTitle: 'Reservierung bestätigt',
      successText: 'Wir freuen uns auf Sie. Die Bestätigung liegt in Ihrem Postfach.',
      viewMenu: 'Speisekarte ansehen',
      errorTitle: 'Etwas ist schiefgelaufen',
      readyScript: 'Buon ritorno!',
      readyTitle: 'Ein Platz ist frei',
      readyText: 'Ein Tisch ist verfügbar geworden — du kannst die Reservierung jetzt mit einem Klick verbindlich machen.',
      guestsLine: '{{guests}} Personen',
      validity: '24 h gültig',
      claiming: 'Buche…',
      claimCta: 'Platz verbindlich sichern',
    },
  },

  footer: {
    address: 'Adresse',
    phone: 'Reservierung',
    hours: 'Öffnungszeiten',
    follow: 'Folge uns',
    newsletter: {
      title: 'Newsletter',
      lede: 'Specials, Saison-Gerichte und Geschichten — <strong>1× im Monat</strong>.',
    },
  },

  events: {
    title: 'Events & Ape-Buchung',
    eyebrow: 'Eventi',
    scriptLine: 'La nostra Ape',
    lede: 'Wir bringen unseren Steinofen zu Ihrem Event — Hochzeit, Stadtfest, Firmenfeier. Frisch gebackene Pizza vor Ort.',
    upcoming: 'Wir sind hier',
    upcomingEmpty: 'Aktuell keine öffentlichen Termine — schreib uns für eine Privat-Buchung.',
    publicEmptyTitle: 'Aktuell keine geplanten öffentlichen Auftritte',
    publicEmptyDescription: 'Wir planen ständig neue Events — schaut bald wieder vorbei oder folgt uns auf Instagram.',
    requestCta: 'Anfrage senden',
    checkAvailability: 'Verfügbarkeit prüfen',
    detailsLink: 'Details ansehen',
    detailBack: 'Alle Events',
    detailFallbackTitle: 'Öffentliches Event',
    calculator: {
      button: 'Schätzung berechnen',
      calculating: 'Berechne…',
      title: 'Unverbindliche Sofort-Schätzung',
      persons: 'Personen',
      travelIncluded: 'Anfahrt: inklusive',
      travelOneWay: 'Anfahrt',
      travelRoundTrip: 'An- & Abfahrt',
      disclaimer:
        'Unverbindliche Schätzung — dein verbindliches Angebot bekommst du nach persönlicher Rücksprache per E-Mail.',
      osm: 'Entfernung: © OpenStreetMap contributors',
      disabled:
        'Die Sofort-Schätzung ist gerade nicht verfügbar — sende die Anfrage einfach ab, wir melden uns mit einem Angebot.',
      belowMin:
        'Für kleinere Gruppen erstellen wir gern ein individuelles Angebot — sende die Anfrage einfach ab.',
      beyondMax:
        'Der Veranstaltungsort liegt außerhalb unseres Standard-Gebiets — wir prüfen deine Anfrage manuell und melden uns.',
      geocodeFailed:
        'Wir konnten den Ort nicht zuordnen — wir prüfen deine Anfrage manuell und melden uns.',
      imprecise:
        'Für diese Adresse können wir die Entfernung nicht genau genug bestimmen — mit Straße und Hausnummer klappt es meist. Sonst sende die Anfrage einfach ab, wir rechnen von Hand.',
    },
    requestForm: {
      title: 'Ape buchen',
      lede: 'Senden Sie uns Ihre Eckdaten — wir melden uns mit einem persönlichen Angebot innerhalb von 24h.',
      date: 'Datum',
      eventType: 'Anlass',
      startTime: 'Uhrzeit',
      endTime: 'bis (optional)',
      expectedGuests: 'Personen (ca.)',
      salutationOptions: { herr: 'Herr', frau: 'Frau', keine: 'Keine Angabe' },
      titleOptions: { dr: 'Dr.', prof: 'Prof.', prof_dr: 'Prof. Dr.' },
      locationHeading: 'Wo findet es statt?',
      locationName: 'Name der Location',
      locationNameHint: 'z. B. „Schützenhalle Lembeck" — freiwillig',
      locationAddress: 'Adresse',
      locationStreet: 'Straße & Hausnummer (optional)',
      locationStreetHint: 'Freiwillig — macht die Entfernungsschätzung genauer',
      locationZip: 'PLZ',
      locationCity: 'Ort',
      phoneHint: 'Für telefonische Rückfragen zu deiner Anfrage',
      isPublic: 'Öffentliche Veranstaltung — kann auf unserer Website angezeigt werden',
      message: 'Nachricht',
      salutation: 'Anrede',
      academicTitle: 'Titel',
      academicTitleNone: 'kein Titel',
      firstName: 'Vorname',
      lastName: 'Nachname',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      submit: 'Anfrage senden',
      sending: 'Senden…',
    },
    priceMode: {
      pauschal: 'Pauschalpreis',
      pizzaAb: 'ab',
      keinPreis: 'Preis auf Anfrage',
    },
  },

  newsletter: {
    title: 'Newsletter',
    scriptLine: 'Resta in contatto',
    lede: 'Saisonale Specials, Wein-Empfehlungen aus Sizilien und kleine Geschichten aus der Küche. 1× im Monat — keine Werbung, kein Spam.',
    benefits: {
      specials: {
        title: 'Saison-Specials zuerst',
        text: 'Sie erfahren als Erste:r von neuen Gerichten.',
      },
      frequency: {
        title: 'Maximal 1× pro Monat',
        text: 'Keine Flutwelle — versprochen.',
      },
    },
    namePlaceholder: 'Ihr Vorname',
    emailPlaceholder: 'ihre@email.de',
    submit: 'Abonnieren',
    consent: 'Mit der Anmeldung stimmen Sie zu, dass wir Ihnen E-Mails an die genannte Adresse senden dürfen. Abmeldung jederzeit per Klick in jeder Mail.',
    successPending: 'Fast geschafft — bitte E-Mail-Postfach prüfen.',
    confirmed: {
      title: 'Anmeldung bestätigt',
      scriptLine: 'Grazie!',
      lede: 'Wir freuen uns, Sie auf unserer Liste zu haben. Bald hören Sie wieder von uns.',
      alreadyTitle: 'Sie sind bereits angemeldet',
    },
    unsubscribed: {
      title: 'Abmeldung bestätigt',
      lede: 'Sie erhalten keine weiteren Newsletter von uns. Schade — aber wir respektieren Ihre Entscheidung.',
    },
    disabled: {
      title: 'Der Newsletter macht gerade Pause',
      lede: 'Aktuell nehmen wir keine neuen Anmeldungen entgegen. Schauen Sie bald wieder vorbei — oder besuchen Sie uns einfach im Restaurant.',
    },
  },

  contact: {
    title: 'Kontakt & Reservierung',
    eyebrow: 'Contatto',
    scriptLine: 'Benvenuti',
    lede: 'Wir freuen uns auf Sie. Reservieren Sie online oder rufen Sie uns an — eine Reservierung ist besonders an Wochenenden empfohlen.',
    info: {
      title: 'So erreichen Sie uns',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      hours: 'Öffnungszeiten',
      social: 'Folgen Sie uns',
    },
    form: {
      title: 'Schreiben Sie uns',
      lede: 'Wir bestätigen Ihre Anfrage innerhalb von 24 Stunden.',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      subjectOptions: {
        general: 'Allgemein',
        reservation: 'Reservierung',
        event: 'Event-Anfrage',
        catering: 'Catering',
        feedback: 'Feedback',
        other: 'Sonstiges',
      },
      message: 'Anmerkungen',
      messagePlaceholder: 'Allergien, Sonderwünsche, Anlass …',
      consent: 'Ich stimme zu, dass meine Angaben gemäß Datenschutzerklärung verarbeitet werden.',
      submit: 'Nachricht senden',
      submitting: 'Wird gesendet …',
      successTitle: 'Grazie',
      successText: 'Vielen Dank! Ihre Nachricht ist angekommen. Wir melden uns innerhalb von 24 Stunden zurück.',
      newMessage: 'Neue Nachricht',
      preferOnline: 'Lieber direkt reservieren?',
      reserveLink: 'Online-Reservierung →',
    },
    map: {
      address: 'Im Werth 25 · 46282 Dorsten',
      openLarger: 'Größere Karte öffnen →',
    },
    faq: {
      eyebrow: 'Häufige Fragen',
      title: 'Vielleicht haben wir die Antwort',
    },
  },

  notFound: {
    scriptLine: 'Mi dispiace',
    title: '404',
    lede: 'Die Seite, die Sie suchen, existiert nicht oder wurde verschoben.',
    backHome: 'Zurück zur Startseite',
  },

  aboutUs: {
    title: 'Über uns',
    scriptLine: 'La nostra storia',
    lede: 'Sizilien hat zwei Heimaten — die Insel im Mittelmeer und unser Restaurant in Dorsten. Eine Familie, zwei Wurzeln, eine Leidenschaft.',
    section1: {
      handwritten: 'Salvatore „Toto"',
      title: 'Von Sciacca nach Dorsten',
      p1: 'Salvatore — von allen nur „Toto" genannt — stammt aus Sciacca an der Südwestküste Siziliens, einem Fischerort, in dem das Meer den Tagesablauf bestimmt. Von dort hat er die Küche seiner Heimat mitgebracht: ehrlich, herzlich, sizilianisch.',
      p2: 'Was als Liebe zur eigenen Heimat begann, ist heute "Die Sizilianer" — ein Restaurant, das Sizilien nach Dorsten bringt. Mit Rezepten der Großmütter, mit Zutaten direkt von der Insel, und mit der Überzeugung, dass gutes Essen geteilt werden muss.',
    },
    section2: {
      title: 'Eine Küche zwischen Meer und Vulkan',
      p1: 'Die sizilianische Küche ist keine bloße Variante der italienischen — sie ist eine eigene Welt. Geprägt von Griechen, Arabern, Spaniern und Normannen. Süß und salzig in einem Gericht. Fisch und Land. Pistazie und Zitrone.',
      p2: 'Wir kochen nichts neu. Wir kochen, wie zuhause gekocht wird. Pasta alla Norma. Caponata. Cannoli mit frischer Ricotta. Pizza Vastasa nach Catania-Art. Und Trüffelpasta — weil sich auch klassische Rezepte gerne mal Luxus gönnen.',
      motto: '„Mangiare insieme è vivere insieme."',
    },
    values: {
      first: {
        title: 'Frische Zutaten',
        description: 'Pistazien aus Bronte, Tomaten aus Pachino, Olivenöl aus Castelvetrano — direkt von der Insel.',
      },
      second: {
        title: 'Hausgemacht',
        description: 'Pasta, Saucen, Brot & Dolci entstehen jeden Morgen frisch in unserer Küche.',
      },
      third: {
        title: 'Familie',
        description: 'Bei uns sitzen Sie nicht in einem Restaurant — Sie sitzen am Tisch einer sizilianischen Familie.',
      },
    },
  },
  /**
   * Die Abholtafel (0107). Ersetzt die Gast-SMS, die am 11.09.2026 keine
   * einzige von 52 Bestellungen genutzt hat.
   */
  tafel: {
    pageTitle: 'Abholtafel',
    pageDescription: 'Welche Pizza ist fertig? Die Abholtafel am Pizzawagen der Sizilianer.',
    heading: 'Abholtafel',
    scriptLine: 'Pronto!',
    chooseSale: 'Bei welcher Veranstaltung sind Sie?',
    noSale: 'Gerade läuft kein Verkauf. Die Tafel füllt sich, sobald am Wagen der erste Zettel geschrieben ist.',
    unknownSale: 'Diese Tafel gibt es nicht — oder der Verkauf ist schon geschlossen.',
    ready: 'Bereit zur Abholung',
    inProgress: 'In Arbeit',
    nothingReady: 'Noch nichts fertig.',
    nothingInProgress: 'Gerade ist nichts im Ofen.',
    asOf: 'Stand {{zeit}}',
    waiting: 'seit {{dauer}}',
    loading: 'Tafel wird geladen…',
    loadError: 'Die Tafel ließ sich nicht laden. Sie versucht es in wenigen Sekunden von selbst erneut.',
    disabled: 'Die Abholtafel ist gerade nicht verfügbar.',
    privacyNote: 'Gezeigt werden nur Bestellnummer und — falls genannt — der Vorname. Keine Beträge, keine Bestellinhalte.',
    backToSales: 'Andere Veranstaltung wählen',
  },
  chatbot: {
    launcherLabel: 'Chat öffnen',
    consent: {
      title: 'Chat mit uns starten?',
      body: 'Sie schreiben mit einer KI, nicht mit einem Menschen. Unser Chat-Assistent wird von Baroon AI betrieben. Beim Laden wird Ihre IP-Adresse an Baroon AI übertragen. Ihre Nachrichten laufen über unseren Server; zeitweise speichern wir Gesprächsverläufe dort befristet (30 Tage), um die Antwortqualität zu prüfen — ebenso, welche Seiten Sie bei uns besuchen. Über unsere Website hinaus verfolgen wir Sie nicht.',
      privacy: 'Mehr in der Datenschutzerklärung',
      accept: 'Chat starten',
      decline: 'Lieber nicht',
      error: 'Der Chat konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
      errorTitle: 'Chat nicht verfügbar',
    },
    footerRevoke: 'Chat-Einwilligung widerrufen',
  },
};

export type TranslationResource = typeof de;
